import { RESET_QUOTE, UPLOAD_QUOTE } from "../constants/actionTypes";

const uploadActions = (
  upload = {
    languageFrom: "English",
    languageTo: ["Spanish"],
    subject: "Software / IT",
    urgent: false,
  },
  action
) => {
  switch (action.type) {
    case UPLOAD_QUOTE:
      return { ...upload, ...action.payload };
    case RESET_QUOTE:
      return {
        languageFrom: "English",
        languageTo: ["Spanish"],
        subject: "Software / IT",
      };
    default:
      return upload;
  }
};

export default uploadActions;
